module.exports = __webpack_public_path__ + "img/register-success.9620e471.png";